import { InsertImage } from './insert-image.js';
import { EditImage } from './edit-image.js';
import { ImageObjectFactory } from './image-object-factory.js';
import ImageSettings from './image-settings.js';


export function Image (pEditor)
{
  this.currentImage = null;
  this.execCurrentImage = null;
  this.saveCurrentImage = null;
  this.webkitSelectedImage = null;

  this.inserter = new InsertImage(pEditor, this);
  this.ieditor = new EditImage(pEditor, this);
  this.objectFactory = new ImageObjectFactory(pEditor, this);
  this.imageSettings = new ImageSettings(pEditor, this);

  
  this.reInit = () =>
  {
    this.objectFactory.reInit();
  };
  
  
  const getCurrentImage = () =>
  {
    let currentSelection = pEditor.range.selection.getCurrent(),
        currentRange = pEditor.range.getCurrent(),
        currentImage = null;

    if (BEditor.browser.isIE)
    {
      if (currentSelection.type.toUpperCase() === 'CONTROL' && currentRange.length === 1 && currentRange.item(0).nodeName.toUpperCase() === 'IMG')
      {
        currentImage = currentRange.item(0);
      }
    }
    else
    {
      if ((Math.abs(currentRange.endOffset - currentRange.startOffset) === 1) && (currentRange.startContainer.childNodes) && (currentRange.startContainer.childNodes[currentRange.startOffset]) && (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() === 'IMG'))
      {
        currentImage = currentRange.startContainer.childNodes[currentRange.startOffset];
      }
      else if (BEditor.browser.isWebKit && this.webkitSelectedImage)
      {
        currentImage = this.webkitSelectedImage;
      }
    }

    return (currentImage || null);
  };


  this.isImageSelected = () =>
  {
    return !!getCurrentImage();
  };
  
  
  this.getThumbnailLink = currentImage =>
  {
    let regFileName = /^.*?\/([^\/.]+\.[\/.\s?]{1,3})(?:\s|\?|$)/;

    if (currentImage && currentImage.parentNode && currentImage.parentNode.nodeName.toUpperCase() === 'A')
    {
      let imageFileName = currentImage.src.replace(regFileName, '$1'),
          linkFileName = currentImage.parentNode.href.replace(regFileName, '$1');

      if (imageFileName && linkFileName && imageFileName.toLowerCase() === linkFileName.toLowerCase())
      {
        return currentImage.parentNode;
      }
    }

    return null;
  };


  this.fixBigImageWidth = (isSetAttributes) =>
  {
    let i,
        element,
        elements = pEditor.iFrameDoc.body.querySelectorAll((isSetAttributes ? 'IMG:not([width])' : 'IMG[data-wawidth]'));

    for (i = 0; i < elements.length; i++)
    {
      element = elements[i];

      if (isSetAttributes)
      {
        if (element.style.width == null || element.style.width === '')
        {
          element.setAttribute('data-wawidth', '1');
          element.setAttribute('width', element.offsetWidth);
          element.style.width = 'auto';
        }
      }
      else
      {
        element.removeAttribute('data-wawidth');
        element.removeAttribute('width');
        element.style.width = '';
      }
    }
  };


  this.getCurrentImage = getCurrentImage;
}